import * as t from './actionTypes';

export type ReducerAction = {
  type: string;
  route: string;
  response: any;
};

const initialState = {
  routes: {},
};

export const adminAppReducer = (state = initialState, action: ReducerAction) => {
  switch (action.type) {
    case t.SEND_POST_RESPONSE:
      return {
        ...state,
        routes: {
          ...state.routes,
          [action.route]: action.response,
        },
      };
    default: {
      return state;
    }
  }
};
